import { render } from "./SystemDirectoryApiModelHistory.vue?vue&type=template&id=469733d1"
import script from "./SystemDirectoryApiModelHistory.vue?vue&type=script&lang=js"
export * from "./SystemDirectoryApiModelHistory.vue?vue&type=script&lang=js"

import "./SystemDirectoryApiModelHistory.vue?vue&type=style&index=0&id=469733d1&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__